import { connect } from 'react-redux';
import CartSummary from '../components/Cart/CartSummary';
import { updateQuantity, finaliseQuantity, removeItem, openNoteModal } from '../actions/cartActions';
import { getCartList } from '../selectors/cartSelector';

const mapStateToProps = function (store) {
    return {
        isLoading: store.cart.isLoading,
        isRowLoading: store.cart.isRowLoading,
        list: getCartList(store.cart.list),
        detail: store.cart.detail,
        currencyFormat: store.cart.currencyFormat,
        currencyDisplayCode: store.cart.currencyDisplayCode,
        locale: store.cart.locale,
    };
};
const mapDispatchToProps = function (dispatch, ownProps) {
    return {
        removeItem: (identifier, callback) => dispatch(removeItem(identifier, callback)),
        updateQuantity: (item, qty) => dispatch(updateQuantity(item, qty)),
        finaliseQuantity: (item, qty) => dispatch(finaliseQuantity(item, qty)),
        openNoteModal: (id) => dispatch(openNoteModal(id)),
    };
};
const ConnectedCartSummary = connect(
    mapStateToProps,
    mapDispatchToProps
)(CartSummary);

export default ConnectedCartSummary;
